<script>
  import { filtersConfigStore } from "@stores/filtersConfigStores.js";
  import {
    DataTable,
    Pagination,
    DataTableSkeleton,
  } from "carbon-components-svelte";
  import { formatTimeDelta } from "lib/util/formatfunctions.js";
  import { SectionWrapper } from "paxray-components-svelte";
  import Header from "lib/components/Header.svelte";
  import { pmfilters } from "lib/stores.js";
  import { fetchWithSession } from "lib/util/fetchWithSession.js";
  import FilterToast from "./components/FilterToast.svelte";
  import Filter from "./components/filter/Filter.svelte";

  export let analysisid;

  const { setCurrentView } = filtersConfigStore;

  let view = "Case Explorer";
  let selectedCaseId;
  let selectedActivityId;
  let cases = [];
  let activities = [];
  let interactions = [];
  let loading = true;
  let loadingActivities = false;
  let loadingInteractions = false;
  let headerCases = [
    { key: "id", value: "Object ID" , width:"180px"},
    { key: "startcw", value: "Start CW" },
    { key: "lastcw", value: "Last CW" },
    { key: "nactivities", value: "Activities" },
    { key: "numberOfUniqueTeams", value: "Team(s)"},
    { key: "numberOfHandovers", value: "Handovers"},
    { key: "lastactivity", value: "Last Activity" , width:"300px" },
    { key: "duration", value: "Duration" },
  ];

  let headerActivities = [
    { key: "activity", value: "Activity" },
    { key: "startdelta", value: "Start Delta" },
    { key: "duration", value: "Duration" },
    { key: "team", value: "Team(s)"},
  ];

  let headerInteractions = [
    { key: "clearname", value: "Application" },
    { key: "windowtitle", value: "Window" },
    { key: "name", value: "UI Element" },
    { key: "eventtype", value: "Action" },
    { key: "startdelta", value: "Activity Delta" },
  ];

  let pagination = {
    page: 1,
    pageSize: 10,
    total: 0,
    totalPages: 0,
  };

  let showToast = false;
  $: setCurrentView(view);

  function ensureRowIds(rows, prefix = "row") {
    if (!Array.isArray(rows)) return [];
    return rows.map((row, index) => ({
      ...row,
      id:
        row?.id ??
        row?.activityid ??
        row?.activity_id ??
        row?.caseid ??
        `${prefix}-${index}`,
    }));
  }

  $: {
    if ($pmfilters && $filtersConfigStore.storeLoaded) getCases();
  }

  function getCases() {
    const applicableFilters = [];
    const filterString = JSON.stringify(applicableFilters);
    fetchWithSession(
      `/api/analysis/cases/getCases/${analysisid}?filter=${filterString}`
    )
      .then((response) => {
        if (response.status === 204) {
          loading = false;
          showToast = true;
          cases = [];
          return;
        }
        return response.json();
      })
      .then((data) => {
        if (!data) {
          showToast = true;
          loading = false;
          return;
        }
        cases = data;
        cases = cases.map((caseItem) => {
          const { caseid, ...rest } = caseItem;
          return { id: caseid, ...rest };
        });
        loading = false;
      });
  }

  function getActivities(selectedCaseId) {
    loadingActivities = true;
    const applicableFilters = [];
    const filterString = JSON.stringify(applicableFilters);
    fetchWithSession(
      `/api/analysis/cases/getActivities/${analysisid}?caseid=${selectedCaseId}&filter=${filterString}`
    )
      .then((response) => response.json())
      .then((data) => {
        activities = ensureRowIds(data, "activity");
        selectedActivityId = [];
        if (
          (Array.isArray(data) && data.length === 0) ||
          (typeof data === "object" &&
            data !== null &&
            Object.keys(data).length === 0)
        ) {
          showToast = true;
        }
        loadingActivities = false;
      });
  }

  $: {
    if (selectedCaseId && selectedCaseId[0]) {
      getActivities(selectedCaseId[0]);
    } else {
      activities = [];
    }
  }

  $: {
    if (
      selectedCaseId &&
      selectedCaseId[0] &&
      selectedActivityId &&
      selectedActivityId[0] &&
      $filtersConfigStore.storeLoaded
    ) {
      loadingInteractions = true;
      const applicableFilters = [];
      const filterString = JSON.stringify(applicableFilters);
      fetchWithSession(
        `/api/analysis/cases/getInteractions/${analysisid}?caseid=${selectedCaseId}&activityid=${selectedActivityId}&filter=${filterString}`
      )
        .then((response) => response.json())
        .then((data) => {
          interactions = ensureRowIds(data, "interaction");
          loadingInteractions = false;
          if (
            (Array.isArray(data) && data.length === 0) ||
            (typeof data === "object" &&
              data !== null &&
              Object.keys(data).length === 0)
          ) {
            showToast = true;
          }
        });
    } else {
      interactions = [];
      loadingInteractions = false;
    }
  }
</script>

<FilterToast bind:showToast />

<Header section="Object" breadcrumb="Object Explorer">
  <Filter allFiltersDisabled />
</Header>

<SectionWrapper splitScreen={true} fullscreen>
  <main slot="main" class="main">
    <div class="table_wrapper" style="width:30vw; ">
      {#if loading}
        <DataTableSkeleton
          rows={10}
          headers={headerCases}
          showToolbar={false}
          showHeader={false}
          size="short"
        />
      {:else}
        <DataTable
          zebra
          radio
          size="compact"
          headers={headerCases}
          rows={cases}
          sortable
          bind:selectedRowIds={selectedCaseId}
          pageSize={pagination.pageSize}
          page={pagination.page}
        >
          <span slot="cell" let:cell>
            {#if cell.key == "duration"}
              {formatTimeDelta(cell.value)}
            {:else}
              {cell.value || "-"}
            {/if}
          </span>
        </DataTable>
        <Pagination
          bind:pageSize={pagination.pageSize}
          bind:page={pagination.page}
          totalItems={cases.length}
          pageSizes={[10, 25, 50, 75, 100]}
        />
      {/if}
    </div>
    <div class="menu" style="width: 15vw;">
      <div class="menu_wrapper" style="padding-top:0px">
        {#if loadingActivities}
          <DataTableSkeleton
            rows={5}
            headers={headerActivities}
            showToolbar={false}
            showHeader={false}
            size="short"
          />
        {:else}
          <DataTable
            size="compact"
            headers={headerActivities}
            rows={activities}
            expandable
            bind:selectedRowIds={selectedActivityId}
            bind:expandedRowIds={selectedActivityId}
            on:click:row--expand={(e) => {
              if (selectedActivityId?.length > 1) {
                selectedActivityId = [e.detail.row.id];
              }
              return;
            }}
          >
            <div class="menu_wrapper interations" slot="expanded-row">
              {#key interactions}
                {#if loadingInteractions}
                  <DataTableSkeleton
                    rows={5}
                    headers={headerInteractions}
                    showToolbar={false}
                    showHeader={false}
                    size="short"
                  />
                {:else}
                  <DataTable
                    size="compact"
                    headers={headerInteractions}
                    rows={interactions}
                  ></DataTable>
                {/if}
              {/key}
            </div>
          </DataTable>
        {/if}
      </div>
    </div>
  </main>
</SectionWrapper>

<style>
  main,
  .menu {
    flex-grow: 1;
  }

  main {
    flex-grow: 1;
    display: flex;
    flex-direction: row;
  }

  .table_wrapper {
    display: flex;
    flex-direction: column;
    flex-grow: 1;
  }

  .menu_wrapper {
    width: fit-content;
    background-color: white;
    border-radius: 0.5rem;
    min-width: 100%;
    width: 100%;
    padding: 1rem;
  }

  :global(.bx--expandable-row .bx--data-table-container td) {
    padding: 2px 16px !important;
  }

  :global(.bx--expandable-row td[colspan="4"]:first-child) {
    padding: 0 !important;
  }

  .interations {
    padding-left: 30px;
  }
</style>
